import Business from './views/main';

export default Business;
